import { api } from "./api";

export const companyViewApi = (params) => {
    return api.get(`/hub/settings/view-company`, { params: params });
};
export const companyEditApi = (params) => {
    return api.post(`/hub/settings/edit-company`, JSON.stringify(params));
};
